import React from 'react';
import { CustomArrowProps } from 'react-slick';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';

import rightArrow from '@/assets/icons/product-slider-right-arrow.svg';

const NextArrow = (props: CustomArrowProps) => {
  const { className, style, onClick } = props;

  return (
    // <ChevronRightOutlined
    //   style={{ ...style, display: 'block' }}
    //   className={`${className} -translate-y-1/2 text-black hover:text-primary`}
    //   fontSize="large"
    //   onClick={onClick}
    // />
    <div className={`${className} arrow-slider-main before:v2-hidden -right-3 -translate-y-1/2`}>
      <Image src={rightArrow} className="" alt="Right Arrow" onClick={onClick} />
    </div>
  );
};

export default NextArrow;
